import { RealEstateDto } from "api/real-estate";
import { BranchCode } from "api/risk";
import { Sizes } from "components/forms/NumberSelector";
import { usePanel } from "hooks/usePanel";
import { useCallback } from "react";
import { SubscriptionProcessContext, SubscriptionProcessContextProps } from "features/subscription-process/contexts/SubscriptionProcessContext";
import { RealEstateForm } from "../components/real-estate/RealEstateForm";

interface UseRealEstatePanelProps {
  branchCode: BranchCode;
  riskId?: string
  contextValue: SubscriptionProcessContextProps;
  refreshRealEstates: () => void;
  translations: {
    addTitle: string;
    editTitle: string;
  };
}

export const useRealEstatePanel = ({
  branchCode,
  riskId,
  contextValue,
  refreshRealEstates,
  translations
}: UseRealEstatePanelProps) => {
  const { openPanel } = usePanel();

  const openRealEstatePanel = useCallback((realEstateId?: string, parcId?: string) => {
    const isEdit = !!realEstateId;

    openPanel(
      {
        title: isEdit ? translations.editTitle : translations.addTitle,
        size: Sizes["4xl"],
      },
      <SubscriptionProcessContext.Provider value={contextValue}>
        <RealEstateForm
          realEstateId={realEstateId}
          riskId={riskId}
          parcId={parcId}
          refreshRealEstates={refreshRealEstates}
          branchCode={branchCode}
        />
      </SubscriptionProcessContext.Provider>
    );
  }, [riskId, branchCode, contextValue, openPanel, refreshRealEstates, translations]);

  const openCreatePanel = useCallback(() => {
    openRealEstatePanel();
  }, [openRealEstatePanel]);

  // parcId optionnel : si fourni, la suppression depuis le panel retire le bien du parc uniquement
  const openEditPanel = useCallback((realEstate: RealEstateDto, parcId?: string) => {
    openRealEstatePanel(realEstate.id, parcId);
  }, [openRealEstatePanel]);

  return {
    openCreatePanel,
    openEditPanel
  };
};
